export default "__VITE_ASSET__BE4UYbh8__"